import React from 'react';
import '../style/Home.scss';
// components
import Header from '../components/public/Header';
import CarouselComponent from '../components/public/CarouselComponent';
import HomeSideContent from '../components/public/HomeSideContent';
// import YoutubeVideo from '../components/thirdParty/YoutubeVideo';

// React Bootstrap
import { Row, Col, Container, Image } from 'react-bootstrap';
// React Redux
import { connect } from 'react-redux';

function Home({ lang }) {
  const CarouselContent = [
    {
      // number 1
      image:
        ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fteaching1.jpg?alt=media&token=7630c11c-68e9-46e0-8078-7899ca0b39c4',
      caption: 'first caption',
    },
    {
      // number 2
      image:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fteaching2.jpg?alt=media&token=c4624674-4dad-444c-a28b-35fbc915a86d',
      caption: 'first caption',
    },
    {
      // number 3
      image:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fteaching3.jpg?alt=media&token=822b532e-44ce-49df-af00-6d852898553d',
      caption: 'first caption',
    },
    {
      // number 4
      image:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fteaching4.jpg?alt=media&token=53343ddc-4a34-4e24-93a9-62a611873c9f',
      caption: 'first caption',
    },
    {
      // number 5
      image:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Ftibet1.jpg?alt=media&token=876b9fd5-1945-4268-9428-151c382ee044',
      caption: 'first caption',
    },
  ];
  const person =
    'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fkunga.jpg?alt=media&token=988335e3-1cf7-4978-8cc8-f43ff8ebc706';
  return (
    <div>
      <Header />
      <Container>
        <Row>
          <Col lg={8}>
            <CarouselComponent item={CarouselContent} />
          </Col>
          <Col>
            <HomeSideContent />
          </Col>
        </Row>
        <div className='message d-flex bg-primary'>
          <Row className='w-100 d-flex align-items-center m-lg-5 m-sm-2'>
            <Col sm='12' lg='6'>
              <Image src={person} fluid thumbnail className='person' />
            </Col>
            <Col className='w-100  text-left ml-3'>
              {lang === 'CH' ? (
                <>
                  <h1 className='messageTitle'>禪修 x 解</h1>
                  <p className='messageBody'>
                    當你有個「我」時，任何的思考都有個二元對立。因為都是透過「我」所看到、所遇到、而批判....。這一切都是「依我」而有所體會，而不是「無我」才能體會。所以都不是真實都不是實相。感官世界皆是有動有靜，像敲一下杯子所發出的聲音，聲音是「動」，而有我就有聲音，所以有發出的聲音就有「二元對立」。動是情緒好壞分別的一個功能；靜是本來的、原來的，不會有快樂不快樂的分別。我、五蘊、五根就像是一面鏡子，透過它來體會酸甜苦辣的情緒，再從動、靜的兩個世界去觀察。因此所聽所見的東西，都是透過鏡子而反射出去。本來的、自然的、原來的都沒有所謂的「我」的存在，是本俱即有。就因為現在的我們是「依我」而活著，所以才會像鏡子般把所有的東西都反射出去。因此也才會有我的計劃、我的行程、我的父母、我的所有感官、感覺、情緒....。其實沒有了這些我們才是真正有「生命」，才能體會到真正的「活著」。所以說是最舒服、自在、快樂也不過如此。我們不應該用這種感受來困惑自己、蒙蔽自己，就是要放鬆、放下。實相、本性、真實，不要用肉體上的感官、覺受來矇蔽自己，那只是看到情緒上的迷失、困惑。這就是「解」，解開的「解」，應該被理解的道理。透過實相的了解，把自己被自己所扭曲的「解」，透過幾分鐘的禪修，短暫休息。
                    <br />
                    <br />
                    <p className='text-muted text-right'>
                      -【 倉薩貢噶 仁波切】
                    </p>
                  </p>
                </>
              ) : lang === 'TIB' ? (
                <>
                  <h1 className='messageTitle'>禪修 x 解</h1>
                  <p className='tibetan_OuChan2 messageBody'>
                    བོད་ཡིག
                    <br /> <br />
                    <p className='text-muted text-right'>
                      - ཚང་གསར་ཀུན་དགའ་རིན་པོ་ཆེ།
                    </p>
                  </p>
                </>
              ) : (
                <>
                  <h1 className='messageTitle'>Meditation & solution</h1>
                  <p className='messageBody'>
                    When you have an "I", any thinking has a duality. Because it
                    is through "I" that I see, encounter, and criticize... All
                    of this is to be experienced "according to me", not
                    "no-self". So neither is truth nor reality. In the sensory
                    world, there is movement and stillness, like the sound of a
                    tap on a cup. The sound is "movement", and when there is me,
                    there is a sound, so when there is a sound, there is a "dual
                    opposition." Movement is a function of the distinction
                    between good and bad emotions; stillness is original and
                    original, and there is no difference between happiness and
                    unhappiness. I, the five aggregates, and the five roots are
                    like a mirror through which to experience the ups and downs
                    of emotions, and then observe from the two worlds of
                    movement and silence. Therefore, everything you hear and see
                    is reflected through the mirror. There is no so-called "I"
                    in the original, natural, or original existence. Just
                    because we are living "according to me" now, we can reflect
                    everything like a mirror. Therefore, there will be my plans,
                    my schedule, my parents, all my senses, feelings,
                    emotions... In fact, without these, we can truly have "life"
                    and only then can we experience the true "living". So it is
                    the most comfortable, comfortable, and happy. We should not
                    use this feeling to confuse and deceive ourselves, but to
                    relax and let go. Reality, nature, and reality. Don’t use
                    your physical senses and feelings to blind yourself. It’s
                    just seeing emotional loss and confusion. This is the
                    "solution", the untangled "solution" should be understood.
                    Through the understanding of reality, you can "resolve" the
                    twisted one yourself, and take a short rest through a few
                    minutes of meditation. <br />
                    <br />
                    <p className='text-right text-muted'>
                      -Tsangsar Kunga Rinpoche
                    </p>
                  </p>
                </>
              )}
            </Col>
          </Row>
        </div>
        <div>
          <Row>
            <Col>
              {/* <YoutubeVideo
                videoId='dtKciwk_si4'
                width='640'
                height='390'
                fluid
              /> */}
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(Home);
